import { gql } from '@apollo/client';
import amplitude from 'amplitude-js';

import env from 'env';
import { AmplitudeUserFragment } from 'types/graphql';

gql`
  fragment AmplitudeUser on User {
    id
    segments

    teams {
      node {
        slug
      }
    }
  }
`;

export function initAmplitude(instruqtUser?: AmplitudeUserFragment) {
  amplitude.getInstance().init(env.amplitudeApiKey, instruqtUser?.id, {
    apiEndpoint: `${window.location.host}/analytics/amplitude`,
  });

  new amplitude.Identify(); // does nothing, must call one of the following methods and pass to client

  var userProperties = {
    segments: instruqtUser ? instruqtUser?.segments : ['anonymous'],
    teams: instruqtUser?.teams?.map(team => team?.node?.slug),
  };
  amplitude.getInstance().setUserProperties(userProperties);
}
